import { useEffect } from 'react';
import { units } from '@ui/css';
import { applyCssDeclarations } from '@utils/css';
import { overlayTokens } from './atom.card-overlay.style.js';

function useOverlayWidth(cardRef, overlayRef) {
  useEffect(() => {
    const card = cardRef.current;
    const overlay = overlayRef.current;
    if (!card || !overlay) {
      return;
    }
    const applyWidth = () => {
      applyCssDeclarations(overlayTokens.__override({
        width: units.px(card.clientWidth)
      }), overlay);
    };
    applyWidth();
    const observer = new ResizeObserver(applyWidth);
    observer.observe(card);
    return () => {
      observer.disconnect();
    };
  });
}

export { useOverlayWidth };
//# sourceMappingURL=hook.overlay-width.js.map
